// hooks/useEmailJS.ts
import { useState, useCallback } from 'react';
import emailjs from '@emailjs/browser';

interface EmailJSHookConfig {
  serviceId: string;
  templateId: string;
  publicKey: string;
  formData: object;
}

interface EmailJSResponse {
  isLoading: boolean;
  error: string | null;
  success: boolean;
  sendEmail: () => Promise<void>;
  reset: () => void;
}

export const useEmailJS = (config: EmailJSHookConfig): EmailJSResponse => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const sendEmail = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    setSuccess(false);

    try {
      await emailjs.send(config.serviceId, config.templateId, {...config.formData}, config.publicKey);
      setSuccess(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to send email');
    } finally {
      setIsLoading(false);
    }
  }, [config]);

  const reset = useCallback(() => {
    setError(null);
    setSuccess(false);
    setIsLoading(false);
  }, []);

  return { isLoading, error, success, sendEmail, reset };
};